var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 178,
    viewBox: "0 0 137 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3292_5232)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9609 98.6763L67.4457 108.194L33.9704 166.175L24.3623 144.747L50.9609 98.6763Z",
    fill: "#418ED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9609 98.6763L34.4761 89.1588L1.0008 147.14L24.3623 144.747L50.9609 98.6763Z",
    fill: "#2B63A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4766 98.6763L57.9918 108.194L91.4671 166.175L101.075 144.747L74.4766 98.6763Z",
    fill: "#2B63A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4766 98.6763L90.9614 89.1588L124.437 147.14L101.075 144.747L74.4766 98.6763Z",
    fill: "#418ED6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6914,
    cy: 58.7539,
    r: 57.2539,
    fill: "#E3E3E3",
    stroke: "#404040"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6922,
    cy: 58.7537,
    r: 44.3016,
    fill: "#595959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3292_5232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 19,
    width: 90,
    height: 89
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.057,
    cy: 63.4833,
    r: 44.4047,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3292_5232)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.6937,
    cy: 58.7538,
    r: 44.4047,
    fill: "url(#paint0_linear_3292_5232)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9315 27.8623L72.5102 47.0197L91.6676 49.4144L78.5129 64.1656L82.0889 85.3346L62.9315 75.7559L43.774 85.3346L47.382 64.1656L34.1953 49.4144L53.3528 47.0197L62.9315 27.8623Z",
    fill: "url(#paint1_linear_3292_5232)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3292_5232",
    x: 0.216502,
    y: 0.216502,
    width: 135.973,
    height: 177.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3292_5232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3292_5232",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3292_5232",
    x1: 62.6937,
    y1: 14.3491,
    x2: 62.6937,
    y2: 103.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CA1A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3292_5232",
    x1: 62.9315,
    y1: 27.8623,
    x2: 62.9315,
    y2: 85.3346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver_medal.b7734e0c0de57c820182930a4b0b2cc3.svg";
export { ForwardRef as ReactComponent };